/**
 * @purpose: menambahkan floating horizontal scrollbar sinkron untuk tabel purchase reason log saat scroll vertikal.
 * @called_by: views/app_report/purchase_reason_log.html melalui directive purchase-reason-sticky-scroll.
 * @deps: AngularJS app, $timeout, $window.
 * @public: directive purchaseReasonStickyScroll.
 * @side_effects: memanipulasi DOM scrollbar horizontal mengambang, membaca posisi viewport, dan menyinkronkan posisi scroll tabel.
 */
app.directive('purchaseReasonStickyScroll', ['$timeout', '$window', function ($timeout, $window) {
    return {
        restrict: 'A',
        link: function (scope, element) {
            var hostNode = element && element[0] ? element[0] : null;
            var stickyBar;
            var stickyInner;
            var syncPromise = null;
            var syncLock = false;
            var mutationObserver = null;
            var resizeObserver = null;
            var winElement = angular.element($window);

            if (!hostNode) {
                return;
            }

            stickyBar = angular.element('<div class="purchase-reason-log-sticky-scroll hidden"></div>');
            stickyInner = angular.element('<div class="purchase-reason-log-sticky-scroll__inner"></div>');
            stickyBar.append(stickyInner);
            element.after(stickyBar);

            function syncScrollFromTable() {
                if (syncLock) {
                    return;
                }
                syncLock = true;
                stickyBar[0].scrollLeft = hostNode.scrollLeft;
                syncLock = false;
            }

            function syncScrollFromSticky() {
                if (syncLock) {
                    return;
                }
                syncLock = true;
                hostNode.scrollLeft = stickyBar[0].scrollLeft;
                syncLock = false;
            }

            function refreshStickyBar() {
                var hostRect = hostNode.getBoundingClientRect();
                var viewportHeight = $window.innerHeight || document.documentElement.clientHeight || 0;
                var viewportWidth = $window.innerWidth || document.documentElement.clientWidth || 0;
                var scrollWidth = hostNode.scrollWidth || 0;
                var clientWidth = hostNode.clientWidth || 0;
                var hasOverflow = scrollWidth > clientWidth + 1;
                var visibleLeft = Math.max(hostRect.left, 0);
                var visibleRight = Math.min(hostRect.right, viewportWidth);
                var visibleWidth = Math.max(0, visibleRight - visibleLeft);
                var isHostVisible = hostRect.top < viewportHeight && hostRect.bottom > 0;

                stickyInner.css('width', scrollWidth + 'px');
                if (hasOverflow && isHostVisible && visibleWidth > 0) {
                    stickyBar.removeClass('hidden');
                    stickyBar.css({
                        position: 'fixed',
                        left: visibleLeft + 'px',
                        width: visibleWidth + 'px',
                        bottom: '0px'
                    });
                    syncScrollFromTable();
                } else {
                    stickyBar.addClass('hidden');
                    stickyBar.css({
                        left: '',
                        width: '',
                        bottom: ''
                    });
                    stickyBar[0].scrollLeft = 0;
                }
            }

            function scheduleRefresh() {
                if (syncPromise) {
                    $timeout.cancel(syncPromise);
                }
                syncPromise = $timeout(function () {
                    syncPromise = null;
                    refreshStickyBar();
                }, 0, false);
            }

            element.on('scroll', syncScrollFromTable);
            stickyBar.on('scroll', syncScrollFromSticky);
            winElement.on('scroll', scheduleRefresh);
            winElement.on('resize', scheduleRefresh);

            if ($window.MutationObserver) {
                mutationObserver = new $window.MutationObserver(scheduleRefresh);
                mutationObserver.observe(hostNode, {
                    childList: true,
                    subtree: true,
                    attributes: true
                });
            }

            if ($window.ResizeObserver) {
                resizeObserver = new $window.ResizeObserver(scheduleRefresh);
                resizeObserver.observe(hostNode);
                if (hostNode.firstElementChild) {
                    resizeObserver.observe(hostNode.firstElementChild);
                }
            }

            scheduleRefresh();

            scope.$on('$destroy', function () {
                if (syncPromise) {
                    $timeout.cancel(syncPromise);
                    syncPromise = null;
                }
                element.off('scroll', syncScrollFromTable);
                stickyBar.off('scroll', syncScrollFromSticky);
                winElement.off('scroll', scheduleRefresh);
                winElement.off('resize', scheduleRefresh);
                if (mutationObserver) {
                    mutationObserver.disconnect();
                    mutationObserver = null;
                }
                if (resizeObserver) {
                    resizeObserver.disconnect();
                    resizeObserver = null;
                }
                stickyBar.remove();
            });
        }
    };
}]);
